module.exports = __webpack_public_path__ + "img/Frame-96.9a237075.svg";